import React from "react";
import "./TextBox.css";

function TextBox() {
  return (
    <div className="text-box">
      <h2>Make Your Reservations for Fire Island Pines Season 2026!</h2>
      <p>
        Discover the best-kept secret of the Pines—a charming, private cottage
        that's perfect for your getaway. Enjoy the comfort of air conditioning,
        a private cedar bathroom, and modern amenities including:
      </p>
      <ul>
        <li>Flat Screen Direct TV & Free WiFi</li>
        <li>Fully Enclosed Outdoor Shower</li>
        <li>
          Washer and Dryer (available for weekly renters; owner use on weekends)
        </li>
        <li>
          Full-Service Kitchen in the main house with:
          <ul>
            <li>Dishwasher</li>
            <li>Air Conditioning</li>
            <li>Free WiFi</li>
            <li>Outside Gas BBQ Grill</li>
            <li>Hot Tub on the front deck with spectacular sunset views</li>
            <li>Wood Burning Fireplace (used in spring and fall)</li>
          </ul>
        </li>
      </ul>
      <p>We provide all bedding, bath linens, beach towels, and umbrellas.</p>
      <h3>Accommodation Details:</h3>
      <p>Two bedrooms are available in main house:</p>
      <ul>
        <li>One with a queen size bed</li>
        <li>One with a full size bed</li>
        <li>Both rooms have air conditioning</li>
      </ul>
      <p>Separate cottage is also available:</p>
      <ul>
        <li>Full size bed</li>
        <li>Air conditioning</li>
        <li> Bathroom </li>
      </ul>
      <p>Each bedroom and the main gallery have Direct TV and Free WiFi.</p>
      <h3>Rental Options:</h3>
      <p>Daily, Weekend, or Weekly rentals available:</p>
      <p>
        <strong> Non-Holiday Pricing (2-Night Minimum):</strong>
      </p>
      <ul>
        <li>Rooms: Starting at $375 per night</li>
        <li>Cottage: Starting at $400 per night</li>
      </ul>
      <p>
        <strong>Holiday Pricing (3-Night Minimum):</strong>
      </p>
      <ul>
        <li>Rooms: Starting at $400 per night</li>
        <li>Cottage: Starting at $425 per night</li>
      </ul>
      <p>
        <strong>Pines Party Pricing (3-Night Minimum):</strong>
      </p>
      <ul>
        <li>Rooms: $450 per night</li>
        <li>Cottage: $475 per night</li>
      </ul>
      <p>
        <strong>Special Spring & Fall Pricing (starting October):</strong>
      </p>
      <ul>
        <li>Rooms: $275 per night</li>
        <li>Cottage: $325 per night</li>
      </ul>
      <p>
        A 50% deposit is required to hold your reservation. Maximum occupancy is
        2 people per room or cottage. Utilities are included.
      </p>
      <h3>Book Now and Experience:</h3>
      <p>A hassle-free, fun, and relaxing Fire Island Pines experience.</p>
      <p>All bookings are for adults only (21+). Sorry, no pets allowed.</p>
      <p>
        For availability, pricing, and additional details, please contact us.
      </p>

      <p>We look forward to welcoming you for a fabulous 2025 season!</p>
      <p>
        Visit us on Facebook:{" "}
        <a href="https://www.facebook.com/McKennaOasisFIP/">McKenna Oasis</a>
      </p>
    </div>
  );
}

export default TextBox;
